import { send } from "@utils/fetch";
import { captureException } from "@utils/sentry";

/**
 * Test Pixel - Client side module
 * Sends a request to an endpoint with data that is fed into
 * third party tracking pixels. We validate the data and
 * log successful or failed validations to datadog.
 *
 * Copyright (C) 2018 Noom Inc.
 * Author: Patrick
 */
class TestPixel {
  constructor(endpoint = null) {
    this.endpoint = endpoint || `/pixel/t/track/`;
  }

  trackEvent(eventName, data) {
    const payload = {
      event: eventName,
      data,
    };
    this.track(payload);
  }

  track(payload) {
    return send("POST", this.endpoint, payload).catch((e) => {
      captureException(e, "TextPixel-Failed to fetch");
    });
  }
}

export default TestPixel;
